import { Mail, MessageCircle } from "lucide-react";
import { ROLE_LABEL } from "@/lib/roles";
import { TestButton } from "@/components/NotifyTestButton";
import { NOTIFY } from "@/constants/testIds";

const Status = ({ on, icon: Icon, children }) => (
  <p className={`flex min-w-0 items-center gap-1.5 text-xs ${on ? "text-slate-700" : "text-slate-400"}`}>
    <Icon className={`h-3.5 w-3.5 shrink-0 ${on ? "text-emerald-600" : "text-slate-300"}`} /><span className="truncate">{children}</span>
  </p>
);

export const UserNotifyStatus = ({ u, waOn }) => {
  const waReady = !!u.wa_phone && waOn;
  return (
    <li className="grid gap-3 px-5 py-4 sm:grid-cols-[1.2fr_1.4fr_auto] sm:items-center" data-testid={NOTIFY.row}>
      <div className="min-w-0">
        <p className="truncate font-medium text-slate-900">{u.name}</p>
        <p className="truncate text-xs text-slate-400">@{u.username} · {ROLE_LABEL[u.role]}{!u.active && " · Nonaktif"}</p>
      </div>
      <div className="min-w-0 space-y-1">
        <Status on={!!u.email} icon={Mail}>{u.email || "Email belum diisi"}</Status>
        <Status on={waReady} icon={MessageCircle}>{u.wa_phone || "WhatsApp belum diisi"}</Status>
      </div>
      <div className="flex gap-2">
        <TestButton channel="email" userId={u.id} disabled={!u.email} />
        <TestButton channel="whatsapp" userId={u.id} disabled={!waReady} />
      </div>
    </li>
  );
};
